module.exports = __webpack_public_path__ + "static/KIN2-94ef33b1427bf89dd4554861c33a7b3f.jpg";